import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthenticationService } from '@sick-bust-sts/sts-core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.authenticationService.oidcClientConfig = environment.oidc;
    this.authenticationService.initializeUser();
  }

  public logout() {
    this.authenticationService.logout();
  }

  public onKeyUp(event: KeyboardEvent) {
    if (event.key !== 'Enter') {
      return;
    }

    this.logout();
  }
}
